/* eslint-disable camelcase */
import { createReducer } from '@reduxjs/toolkit';
import { VettingActions } from './actions';
import { VETTING_STAGES } from '../../../Constants/Common';
import Constants from './constants';

const initialState = {
  stage: VETTING_STAGES.terms,
  vettingTerms: false,
  fields: {
    firstName: null,
    lastName: null,
    email: null,
    phone: null,
    company: null,
    job: null,
    teamSize: null,
    industry: null,
    otherIndustryDescription: null,
    useCaseCode: null,
    useCaseText: null,
    otherDescription: null,
    captcha: null,
    agreeToTerms: null,
  },
  moreInfo: null,
  isLoading: false,
};

const ACTION_HANDLER = {
  [VettingActions.submitVetting]: (state) => {
    state.isLoading = true;
  },
  [VettingActions.submitVettingSucceeded]: (state) => {
    state.isLoading = false;
    state.moreInfo = false;
  },
  [VettingActions.submitVettingFailed]: (state) => {
    state.isLoading = false;
  },
  [VettingActions.updateFields]: (state, action) => {
    const newField = action.payload;
    const key = Object.keys(newField)[0];
    const value = Object.values(newField)[0];
    state.fields = {
      ...state.fields,
      [key]: value,
    };
  },
  [VettingActions.submitVettingStep1]: (state, action) => {
    state.fields = {
      ...state.fields,
      firstName: action.payload.firstName,
      lastName: action.payload.lastName,
      email: action.payload.email,
      phone: action.payload.phone,
    };
  },
  [VettingActions.submitVettingStep2]: (state, action) => {
    state.fields = {
      ...state.fields,
      company: action.payload.company,
      job: action.payload.job,
      teamSize: action.payload.teamSize,
      industry: action.payload.industry,
      otherIndustryDescription: action.payload.otherIndustryDescription,
    };
  },
  [VettingActions.submitVettingStep3]: (state, action) => {
    state.fields = {
      ...state.fields,
      useCaseCode: action.payload.useCaseCode,
      useCaseText: action.payload.useCaseText,
      otherDescription: action.payload.otherDescription,
      captcha: action.payload.captcha,
      agreeToTerms: true,
      product: action.payload.product,
    };
    state.isLoading = true;
  },
  [VettingActions.updateStage]: (state, action) => {
    state.stage = action.payload;
  },
  [VettingActions.agreeToTerms]: (state) => {
    state.vettingTerms = true;
    state.stage = VETTING_STAGES.vettingSteps;
  },
  [VettingActions.getMoreInfo]: (state) => {
    state.stage = VETTING_STAGES.moreInfo;
    state.isLoading = false;
  },
};

export const vettingReducer = createReducer(initialState, ACTION_HANDLER);

export default {
  name: Constants.MODULE_NAME,
  reducer: vettingReducer,
};
